export default __webpack_public_path__ + "static/Obol_Oisin-Kyne_CTO-7e074ad5e07f34388eed9fb229751515.jpeg";